import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import { useTheme } from "../context/ThemeContext";

interface Tutorial {
  title: string;
  description: string;
  videoId: string;
}

interface TutorialCategory {
  category: string;
  icon: string;
  tutorials: Tutorial[];
}

const Tutorial = () => {
  const { currentTheme } = useTheme();
  const [activeTab, setActiveTab] = useState(0);

  // Organize tutorials by category
  const tutorialCategories: TutorialCategory[] = [
    {
      category: "Intro",
      icon: "👋",
      tutorials: [
        {
          title: "Introduction Tutorial",
          description: "Getting started with music learning",
          videoId: "IrhFwXdj3Q8"
        }
      ]
    },
    {
      category: "Music Theory",
      icon: "🎼",
      tutorials: [
         {
          title: "Swar, Notation, Octave",
          description: "Basics of Indian music theory: Swar, Notation, and Octave",
          videoId: "s_IGtgzS5JM"
        },
         {
          title: "Thaat Ragas Basics",
          description: "Basics of Indian music theory: Thaat Ragas",
          videoId: "y4zWMBnpefI"
        },

         {
          title: "Bilaval Thaat Basics",
          description: "Basics of Indian music theory: Bilaval Thaat",
          videoId: "P9XePpqNpXY"
        },
           {
          title: "Khamaj Thaat Basics",
          description: "Basics of Indian music theory: Khamaj Thaat",
          videoId: "j3mYb4uGgDk"
        }
        // Add music theory tutorials here
      ]
    },
    {
      category: "Learn Songs",
      icon: "🎸",
      tutorials: [
         {
          title: "Thaat Ragas Based Songs",
          description: "Know songs based on Thaat Ragas",
          videoId: "VJyKP3msvmk"
        },
        {
          title: "Lag Ja Gale - Song Tutorial (Part 1)",
          description: "Learn to play 'Lag Ja Gale' on guitar - Part 1",
          videoId: "YagUjALhz64"
        },
           {
          title: "Lag Ja Gale - Song Tutorial (Part 2)",
          description: "Learn to play 'Lag Ja Gale' on guitar - Part 2",
          videoId: "1JXuoVy2fg4"
        },
              {
          title: "Mitwa - Song Tutorial (Part 1)",
          description: "Learn to play 'Mitwa' on guitar - Part 1",
          videoId: "myOb6FbJdKk"
        },
           {
          title: "Mitwa - Song Tutorial (Part 2)",
          description: "Learn to play 'Mitwa' on guitar - Part 2",
          videoId: "9KpcZpYuI2o"
        },
         {
          title: "Ye Honsla Kaise Jhuke - Song Tutorial (Part 1)",
          description: "Learn to play 'Ye Honsla Kaise Jhuke' on guitar - Part 1",
          videoId: "GPJ-xQaBy9I"
        },
           {
          title: "Ye Honsla Kaise Jhuke - Song Tutorial (Part 2)",
          description: "Learn to play 'Ye Honsla Kaise Jhuke' on guitar - Part 2",
          videoId: "tuQGshwKfyo"
        },
            {
          title: "Soch Na Sake - Song Tutorial (Part 1)",
          description: "Learn to play 'Soch Na Sake' on guitar - Part 1",
          videoId: "YzrfR4Y4WNo"
        },
           {
          title: "Soch Na Sake - Song Tutorial (Part 2)",
          description: "Learn to play 'Soch Na Sake' on guitar - Part 2",
          videoId: "6c3ECaf6v1M"
        },
         {
          title: "Soch Na Sake - Song Tutorial (Part 3)",
          description: "Learn to play 'Soch Na Sake' on guitar - Part 3",
          videoId: "0VaVHSM1Fv4"
        },
         {
          title: "Vaishnav Jan To - Song Tutorial (Part 1)",
          description: "Learn to play 'Vaishnav Jan To' on guitar - Part 1",
          videoId: "rgn_flKZH78"
        },
           {
          title: "Vaishnav Jan To - Song Tutorial (Part 2)",
          description: "Learn to play 'Vaishnav Jan To' on guitar - Part 2",
          videoId: "Juw9jIZsvHo"
        },
        // Add song learning tutorials here
      ]
    },
    {
      category: "Tips & Tricks",
      icon: "💡",
      tutorials: [
              {
          title: "8 Essential Singing Tips for Beginners",
          description: "Fundamental tips to improve your singing skills",
          videoId: "fSKbDORBR50"
        },
             {
          title: "Know Your Vocal Range",
          description: "Tips to identify and expand your vocal range",
          videoId: "-5FlbCQui6k"
        },
          
             {
          title: "How To Expand Your Vocal Range",
          description: "Techniques to expand your vocal range effectively",
          videoId: "702Hf_OACOc"
        },
       {
          title: "Breath Control for Singers",
          description: "Techniques to improve breath control while singing",
          videoId: "h-t__mWHzUs"
        },
           {
          title: "Singing From Diaphragm",
          description: "Learn to sing using your diaphragm for better control",
          videoId: "tureUMkeX6I"
        },
               {
          title: "Sing Better - Pitch, Rhythm, Pronunciation, Feel",
          description: "Tips and techniques to improve your singing skills",
          videoId: "7M2xexV_vAI"
        },
                 {
          title: "Sing Better - Alap, Taan, Gamak, Meend, Khatka",
          description: "Advanced techniques to enhance your singing style",
          videoId: "uqa4iQxrJN4"
        },
                {
          title: "Sing Better - Vibrato and Modulation",
          description: "Techniques to master vibrato and modulation in singing",
          videoId: "IpVkWJmIpvo"
        }
        // Add tips and tricks tutorials here
      ]
    },
        {
      category: "Daily Riyaz",
      icon: "🎯",
      tutorials: [
        
             {
          title: "Sa Ka Riyaz",
          description: "Daily practice tutorial focusing on Sa note",
          videoId: "35BZvl_CRbM"
        },
             
             {
          title: "Pratice Session to Expand Your Vocal Range",
          description: "A guided practice session to help you expand your vocal range",
          videoId: "lt92MqBlJho"
        }
        // Add daily practice tutorials here
      ]
    },
    {
      category: "Voice Care",
      icon: "🧴",
      tutorials: [
        
             {
          title: "Food Habits for Singers",
          description: "Essential food habits to maintain a healthy singing voice",
          videoId: "0W7cFLVJzsQ"
        }
        // Add daily practice tutorials here
      ]
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
        <Helmet>
            <title>Music Tutorials by Mukesh Rathore | Composer & Music Educator</title>

            <meta
                name="description"
                content="Learn music theory, song learning, daily practice techniques, and creative skills through tutorials by Mukesh Rathore—independent music composer and educator with 28+ years of experience."
            />

            <meta
                property="og:title"
                content="Music Tutorials by Mukesh Rathore | Composer & Music Educator"
            />

            <meta
                property="og:description"
                content="Step-by-step music tutorials by independent music composer and educator Mukesh Rathore, covering theory, practice, and real-world music creation."
            />
            <link rel="canonical" href="https://mukeshrathore.com/tutorial" />
            </Helmet>

      <Navbar />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className={`bg-gradient-to-br ${currentTheme.colors.primary} text-white py-20 px-6`}>
          <div className="max-w-6xl mx-auto text-center">
            <motion.h1 
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-5xl md:text-7xl font-bold mb-6"
            >
              🎓 Music Tutorials
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-xl md:text-2xl text-purple-200 max-w-3xl mx-auto"
            >
              Start learning music with my RagaSpectrum tutorials — designed to help you understand, practice, and apply music confidently.
            </motion.p>
                  <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-xl text-yellow-300 mt-3"
            >
              ✨ <span className="font-semibold">14,000+ learners</span> have already explored music through RagaSpectrum Online Music Academy
            </motion.p>
      
          </div>
        </section>

        {/* Tabs and Tutorials */}
        <section className="py-20 px-6 bg-gray-50">
          <div className="max-w-6xl mx-auto">
            {/* Tabs */}
            <div className="flex gap-3 mb-12 overflow-x-auto pb-2">
              <div className="flex gap-3 mx-auto">
                {tutorialCategories.map((category, index) => (
                  <button
                    key={index}
                    onClick={() => setActiveTab(index)}
                    className={`px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap ${
                      activeTab === index
                        ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg transform scale-105'
                        : 'bg-white text-gray-700 hover:bg-gray-100 shadow'
                    }`}
                  >
                    <span className="mr-2">{category.icon}</span>
                    {category.category}
                  </button>
                ))}
              </div>
            </div>

            {/* Active Category Content */}
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
            >
              {tutorialCategories[activeTab].tutorials.length > 0 ? (
                <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
                  {tutorialCategories[activeTab].tutorials.map((tutorial, index) => (
                    <motion.div
                      key={index}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5, delay: index * 0.1 }}
                      className="bg-white rounded-xl shadow-xl overflow-hidden hover:shadow-2xl transition-all"
                    >
                      <div className="p-6">
                        <div className="flex items-start justify-between mb-4">
                          <div>
                            <h3 className="text-2xl font-bold text-gray-800 mb-2">
                              {tutorial.title}
                            </h3>
                            <p className="text-gray-600 mb-2">{tutorial.description}</p>
                 
                          </div>
                        </div>
                        
                        {/* Embedded YouTube Player */}
                        <div className="mt-4">
                          <div className="relative" style={{ paddingBottom: '56.25%', height: 0 }}>
                            <iframe
                              src={`https://www.youtube.com/embed/${tutorial.videoId}`}
                              title={tutorial.title}
                              frameBorder="0"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                              className="absolute top-0 left-0 w-full h-full rounded-lg"
                            ></iframe>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <p className="text-gray-500 text-xl">No tutorials in this category yet. Coming soon!</p>
                </div>
              )}
            </motion.div>

            {/* Call to Action */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-center mt-16"
            >
              <h3 className="text-3xl font-bold text-gray-800 mb-4">
                Want personalized music guidance?
              </h3>
              <p className="text-xl text-gray-600 mb-8">
                Join Indie Music Creators for structured learning and community support
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => window.open('/zoom', '_blank')}
                className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-4 px-8 rounded-lg text-lg transition-all shadow-xl"
              >
                Join Now →
              </motion.button>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Tutorial;
